module.exports = __webpack_public_path__ + "static/media/iconeConsulta.e51796bd.svg";